

function Kontakt() {
  return <div className="main-wrapper">
    
      

    <h2>Kontakt</h2>

    <h3>
      Ich freue mich, von Ihnen zu hören oder zu lesen.
    </h3>

    <p>
      Sie erreichen mich unter:
    </p>

    <p>
      Telefon: <a href="tel:+49 89 43630078">+49 89 43630078</a><br/>
      E-Mail: <a href="mailto:info@tanztherapie-muenchen.de">info@tanztherapie-muenchen.de</a>
    </p>

    <p>
      Falls ich nicht ans Telefon gehen kann, hinterlassen Sie mir bitte eine Nachricht mit Ihrem Namen und Ihrer Telefonnummer. Vielen Dank!
    </p>

    <p>
      Praxisadresse:<br/>
      Theresienstraße 148<br/>
      D-80333 München
    </p>

    <p>
      U-Bahn:<br/>
      U2 Theresienstraße (Ausgang D)
    </p>

  </div>
}
export default Kontakt;